//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');


export interface InvoicesViewModelOfInvoiceDto {
    invoices?: InvoiceDto[] | undefined;
    paging?: PagingOutput | undefined;
}

export interface InvoicesViewModel extends InvoicesViewModelOfInvoiceDto {
}

export interface TimeStampsDto {
    createdDate?: Date | undefined;
    updatedDate?: Date | undefined;
}

export interface UserTimeStampsDto extends TimeStampsDto {
    createdById?: string | undefined;
    updatedById?: string | undefined;
}

export interface InvoiceDto extends UserTimeStampsDto {
    id?: string;
    description?: string | undefined;
    reference?: string | undefined;
    subTotal?: number;
    taxTotal?: number;
    total?: number;
    creditTotal?: number;
    dueTotal?: number;
    postedDate?: Date | undefined;
    postedById?: string | undefined;
    lineItems?: InvoiceLineItemDto[] | undefined;
    taxTotals?: InvoiceTaxAmountDto[] | undefined;
    status?: InvoiceStatus;
    personId?: string | undefined;
    personForename?: string | undefined;
    personSurname?: string | undefined;
    companyId?: string | undefined;
    companyName?: string | undefined;
    locationId?: number;
    incidentId?: string | undefined;
    printUrl?: string | undefined;
    sageAccountId?: number | undefined;
    sageAccountNumber?: string | undefined;
}

export interface InvoiceLineItemDto {
    id?: string;
    amount?: number;
    subTotal?: number;
    taxTotal?: number;
    total?: number;
    description?: string | undefined;
    quantity?: number;
    invoiceId?: string;
    taxRateId?: string | undefined;
    taxRate?: TaxRateDto | undefined;
    chargeTypeId?: string;
    chargeType?: ChargeTypeDto | undefined;
}

export interface TaxRateDto {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    percentage?: number;
    type?: TaxRateType;
    default?: boolean;
    status?: GenericStatus;
}

export enum TaxRateType {
    Inclusive = "Inclusive",
    Exclusive = "Exclusive",
}

export enum GenericStatus {
    Draft = "Draft",
    Active = "Active",
    Deleted = "Deleted",
}

export interface ChargeTypeDto {
    id?: string;
    name?: string | undefined;
    nominal?: string | undefined;
    color?: string | undefined;
    status?: GenericStatus;
}

export interface InvoiceTaxAmountDto {
    taxRateId?: string;
    taxRate?: TaxRateDto | undefined;
    total?: number;
}

export enum InvoiceStatus {
    Draft = "Draft",
    Active = "Active",
    Posted = "Posted",
    Deleted = "Deleted",
}

export interface PagingOutput {
    next?: boolean;
    prev?: boolean;
    perPage?: number;
    page?: number;
    total?: number;
    totalPages?: number;
}

export interface InvoiceViewModelOfInvoiceDto {
    invoice?: InvoiceDto | undefined;
}

export interface InvoiceViewModel extends InvoiceViewModelOfInvoiceDto {
}

export interface InvoiceViewModelOfInvoiceAddDto {
    invoice?: InvoiceAddDto | undefined;
}

export interface InvoiceBaseDto {
    personId?: string | undefined;
    companyId?: string | undefined;
    locationId?: number;
    description?: string | undefined;
}

export interface InvoiceAddDto extends InvoiceBaseDto {
    incidentId?: string | undefined;
    lineItems?: InvoiceLineItemAddDto[] | undefined;
}

export interface InvoiceLineItemAddDto {
    amount?: number;
    description?: string | undefined;
    quantity?: number;
    taxRateId?: string | undefined;
    chargeTypeId?: string;
}

export interface InvoiceViewModelOfInvoiceEditDto {
    invoice?: InvoiceEditDto | undefined;
}

export interface InvoiceEditDto extends InvoiceBaseDto {
    lineItems?: InvoiceLineItemEditDto[] | undefined;
}

export interface InvoiceLineItemEditDto extends InvoiceLineItemAddDto {
    id?: string | undefined;
}

export interface InvoiceExportViewModel {
    date?: Date;
    invoices?: InvoiceExportDto[] | undefined;
    creditNotes?: InvoiceExportDto[] | undefined;
}

export interface InvoiceExportDto {
    id?: string;
    type?: InvoiceExportType;
    sageAccountId?: number;
    sageAccountNumber?: string | undefined;
    reference?: string | undefined;
    locationNominalCostCentre?: string | undefined;
    subTotal?: number;
    taxTotal?: number;
    total?: number;
    postedDate?: Date;
    lineItems?: InvoiceExportLineItemDto[] | undefined;
}

export enum InvoiceExportType {
    Invoice = "Invoice",
    CreditNote = "CreditNote",
}

export interface InvoiceExportLineItemDto {
    description?: string | undefined;
    subTotal?: number;
    taxTotal?: number;
    total?: number;
    nominalCode?: string | undefined;
}

export interface InvoiceExportPostViewModel {
    invoiceIds?: string[] | undefined;
    creditNoteIds?: string[] | undefined;
}

export interface TaxRatesViewModelOfTaxRateDto {
    taxRates?: TaxRateDto[] | undefined;
    paging?: PagingOutput | undefined;
}

export interface TaxRatesViewModel extends TaxRatesViewModelOfTaxRateDto {
}

export interface TaxRateViewModelOfTaxRateDto {
    taxRate?: TaxRateDto | undefined;
}

export interface TaxRateViewModel extends TaxRateViewModelOfTaxRateDto {
}

export interface TaxRateViewModelOfTaxRateAddDto {
    taxRate?: TaxRateAddDto | undefined;
}

export interface TaxRateAddDto {
    name?: string | undefined;
    description?: string | undefined;
    percentage?: number;
    default?: boolean;
    type?: TaxRateType;
}

export interface CreditNotesViewModelOfCreditNoteDto {
    creditNotes?: CreditNoteDto[] | undefined;
    paging?: PagingOutput | undefined;
}

export interface CreditNotesViewModel extends CreditNotesViewModelOfCreditNoteDto {
}

export interface CreditNoteBaseDto extends UserTimeStampsDto {
    id?: string;
    reference?: string | undefined;
    description?: string | undefined;
    subTotal?: number;
    taxTotal?: number;
    total?: number;
    incidentId?: string | undefined;
    locationId?: number;
    invoiceId?: string | undefined;
    invoiceReference?: string | undefined;
    personId?: string | undefined;
    personForename?: string | undefined;
    personSurname?: string | undefined;
    companyId?: string | undefined;
    companyName?: string | undefined;
    postedDate?: Date | undefined;
    postedById?: string | undefined;
    status?: InvoiceStatus;
    printUrl?: string | undefined;
    sageAccountId?: number | undefined;
    sageAccountNumber?: string | undefined;
}

export interface CreditNoteDto extends CreditNoteBaseDto {
    lineItems?: CreditNoteLineItemDto[] | undefined;
    taxTotals?: CreditNoteTaxAmountDto[] | undefined;
}

export interface CreditNoteLineItemDto {
    id?: string;
    amount?: number;
    quantity?: number;
    subTotal?: number;
    total?: number;
    description?: string | undefined;
    creditNoteId?: string;
    invoiceLineItemId?: string | undefined;
    taxRateId?: string | undefined;
    taxRate?: TaxRateDto | undefined;
    chargeTypeId?: string;
    chargeType?: ChargeTypeDto | undefined;
}

export interface CreditNoteTaxAmountDto {
    taxRateId?: string;
    taxRate?: TaxRateDto | undefined;
    total?: number;
}

export interface CreditNoteViewModelOfCreditNoteDto {
    creditNote?: CreditNoteDto | undefined;
}

export interface CreditNoteViewModel extends CreditNoteViewModelOfCreditNoteDto {
}

export interface CreditNoteViewModelOfCreditNoteAddDto {
    creditNote?: CreditNoteAddDto | undefined;
}

export interface CreditNoteAddDto {
    description?: string | undefined;
    locationId?: number | undefined;
    personId?: string | undefined;
    companyId?: string | undefined;
    invoiceId?: string | undefined;
    lineItems?: CreditNoteLineItemAddDto[] | undefined;
}

export interface CreditNoteLineItemAddDto {
    amount?: number;
    quantity?: number;
    description?: string | undefined;
    chargeTypeId?: string;
    taxRateId?: string | undefined;
    invoiceLineItemId?: string | undefined;
}

export interface PagingViewModel {
    paging?: PagingOutput | undefined;
}

export interface ChargeTypesViewModelOfChargeTypeDto extends PagingViewModel {
    chargeTypes?: ChargeTypeDto[] | undefined;
}

export interface ChargeTypesViewModel extends ChargeTypesViewModelOfChargeTypeDto {
}

export interface ChargeTypeViewModelOfChargeTypeAddDto {
    chargeType?: ChargeTypeAddDto | undefined;
}

export interface ChargeTypeAddDto {
    name?: string | undefined;
    nominal?: string | undefined;
    color?: string | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

